import { ScheduleSliceState } from '../index';
import { getDayFromState } from 'modules/schedule/store/utils/get-day-from-state';

export const markToday = (state: ScheduleSliceState) => {
  const today = new Date();
  const weekDay = getDayFromState(state, today);
  if (weekDay) weekDay.status = 'today';
};
